import { debounce, kebabCase } from 'lodash';
import {equals, always, when, curriedFilter, curriedMap, curriedPick, compose} from '@core/lib/fp';

function appSwitcher() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./app-switcher.html'),
    scope: {},
    controller: 'AppSwitcherController',
    controllerAs: 'vm',
    bindToController: {
      app: '=',
      screen: '=',
      currentTab: '='
    }
  };
}

function AppSwitcherController($scope, $rootScope, $element, $state, App, Helper) {
  'ngInject';
  const vm = this;
  let _pristineList = [];

  const allowedTabs = ['overview', 'cost', 'fraud-prevention', 'cohorts'];

  vm.isLoading = true;
  vm.isEmpty = false;
  vm.isActive = false;
  vm.searchTerm = '';
  vm.apps = null;

  vm.changeApp = changeApp;

  $rootScope.$on('flyout:open:app-switcher', _handleInit);
  $rootScope.$on('flyout:closed:app-switcher', _handleDestroy);
  $scope.$watch('vm.searchTerm', debounce(_handleSearch, 200));

  /**
   * @param {String} tab
   * @returns {String}
   * @private
   */
  const _normalizeTab = compose(
    when(equals('deliverables'), always('overview')),
    kebabCase
  );

  /**
   * @param {String} screen
   * @param {String} tab
   * @returns {String}
   * @private
   */
  const _constructRoute = (screen, tab) =>
    [screen, _normalizeTab(tab)].join('.');

  /**
   * @param {Array} apps
   * @returns {Array}
   * @private
   */
  const _selectApps = compose(
    curriedMap(curriedPick(['id', 'token', 'name', 'default_store_app_id'])),
    curriedFilter(app => app.id !== vm.app.id)
  );

  /**
   * @param {String} appToken
   */
  function changeApp(appToken) {
    const tab = allowedTabs.includes(vm.currentTab.value) ? vm.currentTab.value : allowedTabs[0];
    const route = _constructRoute(vm.screen, tab);
    const params = { appToken };

    $state.go(route, params, {
      reload: true,
      inherit: false
    });
    $scope.$broadcast('flyout:toggle');
  }


  /**
   * @private
   */
  function _handleInit() {
    vm.isActive = true;
    _focusSearchField();

    App
      .getApps()
      .then(({apps}) => {
        _pristineList = _selectApps(apps);
        vm.isEmpty = _pristineList.length === 0;
        vm.isLoading = false;
        _updateApps();
      });
  }

  /**
   * @private
   */
  function _handleDestroy() {
    Helper.ready(() => {
      vm.isLoading = true;
      vm.isActive = false;
    });
  }

  /**
   * @private
   */
  function _handleSearch(n, o) {
    if (vm.isLoading || n === o) {
      return;
    }

    _updateApps();
  }

  /**
   * @private
   */
  function _updateApps() {
    Helper.ready(() => {
      vm.apps = _getFilteredList();
    });
  }

  /**
   * @private
   */
  function _focusSearchField() {
    Helper.ready(() => {
      const input = $element[0].querySelector('.search-input');
      input && input.focus();
    });
  }

  /**
   * @returns {Array}
   * @private
   */
  function _getFilteredList() {
    return vm.searchTerm
      ? Helper.filter(_pristineList, vm.searchTerm)
      : _pristineList.slice();
  }
}

export { AppSwitcherController, appSwitcher };
